import { toast } from 'react-toastify';

const toastSuccess = (message, options) => toast.success(message || 'Successfully saved!', options);
const toastError = (message, options) => toast.error(message || 'Oops, something went wrong!', options);
const toastWorking = (message, options) => toast.default(message || 'Working ...', options);

export { toastSuccess, toastError, toastWorking };
